export const InputPerguntas = {
    width: '90%',
    height: '85%',
    display: 'flex',
    justifyContent: 'center'
}

export const BtnDeletePergunta = {
    width: '1%',
    color: 'grey'
}

export const LegendaInputPergunta = {
    width: '1%',
    paddingRight: '2%'
}

export const GridInputPergunta = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center'
}

export const GridPerguntas = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '1%'
}

export const GridBtnsAddAndCopy = {
    width: '50%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1%'
}

export const GridSelecionarEntradas = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1%'
}

export const BoxHorariosRonda = {
    display: 'flex',
    alignItems: 'center',
    width: '78%',
    justifyContent: 'space-evenly'
}

export const BoxAtivarRonda = {
    display: 'flex',
    alignItems: 'center',
    width: '22%',
    justifyContent: 'flex-start'
}

export const GridConfigRonda = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1%'
}

export const GridPaiConfigRonda = {
    display: 'flex',
    flexDirection: 'column'
}

export const ContainerConfigRonda = {
    display: 'flex',
    height: '100%',
    justifyContent: 'space-between',
    flexDirection: 'column'
}

export const BtnsSalvarCancelar = {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1%',
    gap: '50px'
}
